import apiFetch from '../apiFetch'

export default function (token, userId) {
  const queryParams = userId ? `userId=${userId}` : ''
  return apiFetch({ endPoint: `organizedUnit?${queryParams}`, method: 'GET', body: null, token: token })
}
